import { Button } from '@mantine/core';
import { modals } from '@mantine/modals';
import { notifications } from '@mantine/notifications';
import { IconPlus } from '@tabler/icons-react';

import { trpc } from '../../../../../../services/trpc';
import { PaymentForm } from './-payment-form';

export function AddPaymentButton({ customerId }: { customerId: string }) {
  const utils = trpc.useUtils();

  const addPaymentMutation = trpc.projects.addPayment.useMutation({
    onSuccess: () => {
      utils.projects.listPayments.invalidate({ customerId });
      modals.closeAll();
      notifications.show({
        title: 'Paiement ajouté avec succès',
        message: '',
        color: 'green',
      });
    },
  });

  const openAddModal = () => {
    modals.open({
      title: 'Ajouter un paiement',
      children: (
        <PaymentForm
          onSubmit={async values => {
            await addPaymentMutation.mutateAsync({
              customerId,
              amount: Number(values.amount),
              type: values.type,
              date: values.date,
            });
          }}
        />
      ),
    });
  };

  return (
    <Button
      leftSection={<IconPlus size={16} />}
      onClick={openAddModal}
      variant="outline"
    >
      Ajouter un paiement
    </Button>
  );
}
